import { ReactNode } from "react";

import { PathnameUrl } from "@app/constants";
import InfoLayout from "./info-layout";

/* Trang Liên hệ theo bản thiết kế contact.ejs: giữ nguyên chữ, địa chỉ, hotline, fanpage và email. */

const PHONE_ICON = (
  <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" />
);
const FANPAGE = "https://www.facebook.com/pcrenderrdp/";
const MAP_URL =
  "https://www.google.com/maps/search/?api=1&query=S%E1%BB%91%206%20T%E1%BB%B1%20Do%2C%20T%C3%A2n%20Th%C3%A0nh%2C%20T%C3%A2n%20Ph%C3%BA%2C%20H%E1%BB%93%20Ch%C3%AD%20Minh";

const ext = { target: "_blank", rel: "noopener noreferrer" };

const CARDS: {
  icon: ReactNode;
  title: string;
  body: ReactNode;
  wide?: boolean;
}[] = [
  {
    icon: (
      <path d="M3 21h18M5 21V7l7-4 7 4v14M9 21v-4h6v4M9 10h.01M15 10h.01M9 14h.01M15 14h.01" />
    ),
    title: "Công ty",
    body: "Công Ty TNHH Công Nghệ PCRENDER",
    wide: true,
  },
  {
    icon: (
      <>
        <path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z" />
        <circle cx="12" cy="9.5" r="2.5" />
      </>
    ),
    title: "Địa chỉ",
    body: (
      <a href={MAP_URL} {...ext}>
        Số 6 Tự Do, Tân Thành, Tân Phú, Hồ Chí Minh
      </a>
    ),
  },
  {
    icon: PHONE_ICON,
    title: "Hotline",
    body: <a href="tel:0833218888">083 321 8888</a>,
  },
  {
    icon: (
      <path d="M15 3h-2.5A3.5 3.5 0 0 0 9 6.5V9H7v3.5h2V21h3.5v-8.5H15l.5-3.5h-3V7a1 1 0 0 1 1-1H15z" />
    ),
    title: "Fanpage",
    body: (
      <a href={FANPAGE} {...ext}>
        facebook.com/pcrenderrdp
      </a>
    ),
  },
  {
    icon: (
      <>
        <path d="M3 5h18v14H3z" />
        <path d="M3 6l9 7 9-7" />
      </>
    ),
    title: "Email",
    body: <a href="mailto:Support@pcrender.com">Support@pcrender.com</a>,
  },
];

function ContactPage() {
  return (
    <InfoLayout
      current={PathnameUrl.CONTACT}
      title="Liên hệ"
      docTitle="Liên hệ PC Render: hotline 083 321 8888"
    >
      <section className="hero" aria-labelledby="t">
        <h1 id="t">Liên hệ</h1>
        <p className="lead">
          Cần hỗ trợ thuê máy, thanh toán hay hợp tác? Gọi hotline hoặc nhắn tin
          fanpage, chúng tôi sẽ phản hồi sớm nhất.
        </p>
        <div className="cta">
          <a className="btn btn-primary" href="tel:0833218888">
            <svg className="i" viewBox="0 0 24 24" aria-hidden="true">
              {PHONE_ICON}
            </svg>
            Gọi 083 321 8888
          </a>
          <a className="btn btn-ghost" href={FANPAGE} {...ext}>
            Nhắn tin fanpage
          </a>
        </div>
      </section>

      <div className="grid">
        {CARDS.map(({ icon, title, body, wide }) => (
          <div key={title} className={wide ? "card wide" : "card"}>
            <div className="ib">
              <svg className="i" viewBox="0 0 24 24" aria-hidden="true">
                {icon}
              </svg>
            </div>
            <div>
              <h2>{title}</h2>
              <p>{body}</p>
            </div>
          </div>
        ))}
      </div>
    </InfoLayout>
  );
}

export default ContactPage;
